import ClipPath from './clip-path.component';
export default ClipPath;
